import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'split'
})
export class SplitPipe implements PipeTransform {
  transform(value: string, splitBy = ''): string[] {
    if (!value) {
      return [];
    }

    return value.toString().split(splitBy);
  }
}
